import type { GameKindAdapter } from "../shared/adapter";
import { compileTopDownCollect } from "./compiler";
import { evaluateTopDownCollect } from "./evaluator";
import { repairCommandsForTopDownCollect } from "./repair";
import { parseTopDownCollectSpec, type TopDownCollectSpec } from "./spec";

export const topDownCollectAdapter: GameKindAdapter = {
  kind: "top-down-collect",
  briefHints: ["collect", "gather", "scavenger hunt", "harvest", "pick up items"],
  promptSchemaLine:
    '{"kind":"top-down-collect","world":{"width":960,"height":540,"timeLimitSeconds":integer 20-180,"goalCollectibles":integer 3-30,"hazards":integer 0-20,"collectibleGlyph":"one emoji for what is collected, e.g. \\"🍓\\"","hazardGlyph":"one emoji for what is avoided, e.g. \\"🕳️\\""},"player":{"speed":integer 140-420,"playerGlyph":"one emoji for the player, e.g. \\"🐿️\\""}}',
  parseSpec: parseTopDownCollectSpec,
  compile: (spec) => compileTopDownCollect(spec as TopDownCollectSpec),
  evaluate: (spec) => evaluateTopDownCollect(spec as TopDownCollectSpec),
  repairCommandsFor: (spec, failedReceipt) => repairCommandsForTopDownCollect(spec as TopDownCollectSpec, failedReceipt),
};

export type { TopDownCollectSpec } from "./spec";
